import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React, { forwardRef } from 'react';
import Heading from 'components/Heading';
/**
 * This is a light wrapper around the Heading component used
 * by some Card components.
 * It's intentionally kept simple and only allows customising
 * its margin. If you're building a new Card component and
 * this component doesn't quite work for it, consider using
 * the `Heading` or `Text` components directly rather than
 * making this component more configurable.
 */

export var CardTitle = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Heading, _extends({
    ref: ref,
    as: "h3",
    size: "small",
    lineHeight: 1.3
  }, otherProps), children);
});
CardTitle.displayName = 'CardTitle';